import { render, staticRenderFns } from "./EnterId.vue?vue&type=template&id=3b820b9e"
import script from "./EnterId.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports